import styled from "styled-components";

export const Pointer = styled.span`
  cursor: pointer;
`;
